import { Link } from 'react-router-dom';

const STATS = [
  { value: '1800+', label: '收录作品' },
  { value: '24h', label: '资讯更新' },
  { value: '12', label: '题材分类' },
  { value: '100%', label: '剧情详实' },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto max-w-6xl px-4 md:px-6">
      <div className="grid grid-cols-1 gap-8 rounded-xl border border-background-200 bg-background-100 p-6 md:p-10 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="font-label text-xs font-semibold uppercase tracking-[0.3em] text-primary-400">
            About Us
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
            关于奸情影视大全
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            “奸情影视大全”专注于收集与整理情感纠葛题材的电影和电视剧，为用户提供完整的剧情介绍、演员资料与最新影视资讯。
            我们希望通过清晰的内容组织，帮助影迷快速找到感兴趣的作品，深入了解每段故事背后的人物与情感。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            本站所有内容均以影视介绍为目的，不含播放与下载功能，所有数据为演示示例。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {STATS.map((stat) => (
            <div key={stat.label} className="rounded-lg border border-background-200 bg-background-50 p-5 text-center">
              <p className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">{stat.value}</p>
              <p className="mt-1.5 text-xs text-foreground-600 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}